import React, { useState, useEffect } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, Alert, CircularProgress, Grid, LinearProgress } from '@mui/material';
import { Add as AddIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import ModuleHub from '../components/ModuleHub';
import { getBudgets, createBudget, deleteBudget } from '../../../services/api';

const fmt = (v) => parseFloat(v || 0).toLocaleString('en-LK', { style: 'currency', currency: 'LKR' });

const BudgetsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [form, setForm] = useState({ name: '', fiscal_year: new Date().getFullYear(), budget_amount: 0, actual_amount: 0, period_type: 'annual' });

  useEffect(() => { loadData(); }, []);
  const loadData = async () => {
    try { setLoading(true); const r = await getBudgets(); setItems(r.data || []); }
    catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <ModuleHub moduleId="budgeting" showFeatures={false}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mb: 2 }}>
        <Button startIcon={<RefreshIcon />} onClick={loadData}>Refresh</Button>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => setDialogOpen(true)}>Create Budget</Button>
      </Box>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? <CircularProgress /> : (
        <TableContainer component={Paper}><Table>
          <TableHead><TableRow><TableCell>Budget</TableCell><TableCell>Year</TableCell><TableCell align="right">Budget</TableCell><TableCell align="right">Actual</TableCell><TableCell align="right">Variance</TableCell><TableCell>Progress</TableCell><TableCell>Actions</TableCell></TableRow></TableHead>
          <TableBody>{items.map(b => {
            const budget = parseFloat(b.budget_amount);
            const actual = parseFloat(b.actual_amount);
            const variance = budget - actual;
            const pct = budget > 0 ? Math.min(100, (actual / budget) * 100) : 0;
            return (
              <TableRow key={b.id}>
                <TableCell><strong>{b.name}</strong></TableCell>
                <TableCell>{b.fiscal_year}</TableCell>
                <TableCell align="right">{fmt(budget)}</TableCell>
                <TableCell align="right">{fmt(actual)}</TableCell>
                <TableCell align="right" style={{ color: variance >= 0 ? 'green' : 'red' }}>{fmt(variance)}</TableCell>
                <TableCell sx={{ minWidth: 120 }}><LinearProgress variant="determinate" value={pct} color={pct > 100 ? 'error' : 'primary'} /></TableCell>
                <TableCell><Button size="small" color="error" onClick={() => deleteBudget(b.id).then(loadData)}>Delete</Button></TableCell>
              </TableRow>
            );
          })}</TableBody>
        </Table></TableContainer>
      )}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Create Budget</DialogTitle>
        <DialogContent><Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}><TextField fullWidth label="Budget Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} /></Grid>
          <Grid item xs={6}><TextField fullWidth type="number" label="Fiscal Year" value={form.fiscal_year} onChange={(e) => setForm({ ...form, fiscal_year: parseInt(e.target.value) })} /></Grid>
          <Grid item xs={6}><TextField fullWidth type="number" label="Budget Amount" value={form.budget_amount} onChange={(e) => setForm({ ...form, budget_amount: e.target.value })} /></Grid>
        </Grid></DialogContent>
        <DialogActions><Button onClick={() => setDialogOpen(false)}>Cancel</Button><Button variant="contained" onClick={async () => { await createBudget({ ...form, budget_amount: parseFloat(form.budget_amount) }); setDialogOpen(false); loadData(); }}>Save</Button></DialogActions>
      </Dialog>
    </ModuleHub>
  );
};

export default BudgetsPage;
